import { ComponentType } from 'react'
import { HATO_HEART_PATHS } from './paths'
import { lazy } from 'react'

export const HomeHatoHeart = lazy(() => import('pages/hato-heart/HomeHatoHeart'))
export const RedirectHHToLiff = lazy(() => import('pages/RedirectHHToLiff'))
export const BurnPoints = lazy(() => import('pages/hato-heart/BurnPoints'))
export const Coupons = lazy(() => import('pages/hato-heart/Coupons'))
export const HatoHeartFeedback = lazy(() => import('pages/hato-heart/HatoHeartFeedback'))

export interface RoutePage {
  path: string
  component: ComponentType
}

const routePages: RoutePage[] = [
  {
    path: HATO_HEART_PATHS.HOME,
    component: HomeHatoHeart,
  },
  {
    path: HATO_HEART_PATHS.REDIRECT_HH_TO_LIFF,
    component: RedirectHHToLiff,
  },
  {
    path: HATO_HEART_PATHS.BURN_POINTS,
    component: BurnPoints,
  },
  {
    path: HATO_HEART_PATHS.COUPONS,
    component: Coupons,
  },
  {
    path: HATO_HEART_PATHS.FEEDBACK,
    component: HatoHeartFeedback,
  },
]

export default routePages
